// @ts-ignore
import React from "react";
import referal from "../../assets/discovery/referral.svg"
import voucher from "../../assets/discovery/voucher1.svg"
import giveaway from "../../assets/discovery/giveaway.svg"
import freebie from "../../assets/discovery/freebie1.svg"
import exclusive from "../../assets/discovery/exclusive1.svg"
import discount from "../../assets/discovery/discount1.svg"
import testNull from "../../assets/discovery/testNull.png"

type OfferTagProps = {
    offerType: string | undefined | null;
}


const OfferTag = ({ offerType }: OfferTagProps) => {
    let imageSrc: string  
    let text: string 
    let bg: string 
    let border: string 
    let textColor: string 

    switch (offerType) {
        case "Referral":
            imageSrc = referal;
            text = "Referral";
            bg = "bg-[#FFF5DC]";
            border = "border-[#D89700]";
            textColor = "text-[#D89700]";
            break;

        case "Discount":
            imageSrc = discount;
            text = "Discount";
            bg = "bg-[#FFDBCD]";
            border = "border-[#EB4300]";
            textColor = "text-[#EB4300]";
            break;

        case "Exclusive":
            imageSrc = exclusive;
            text = "Exclusive";
            bg = "bg-[#ECDAFF]";
            border = "border-[#44046E]";
            textColor = "text-[#44046E]";
            break;

        case "Voucher":
            imageSrc = voucher;
            text = "Voucher";
            bg = "bg-[#CBDBFFE5]";
            border = "border-[#00206C]";
            textColor = "text-[#00206C]";
            break;

        case "Giveaway":
            imageSrc = giveaway;
            text = "Giveaway";
            bg = "bg-[#FFDCB4]";
            border = "border-[#6E3004]";
            textColor = "text-[#6E3004]";
            break;

        case "Freebie":
            imageSrc = freebie;
            text = "Freebie";

            bg = "bg-[#DAFFB4]";
            border = "border-[#046E0D]";
            textColor = "text-[#046E0D]";
            break;
            
        default:
            imageSrc = testNull;
            text = "loading";
            bg = "transparent";
            border = "border-[#FFFFFF]/30";
            textColor = "text-white/10";
            break;
    }

    return (
        <div className={`rounded-[50px] ${bg} flex justify-center gap-[5px] py-[1.5px] border ${border} px-[10px]`}>
            <img
                src={imageSrc}
                alt={imageSrc}
                width={16}
                height={6}

            />
            <p className={`text-[11px] ${textColor}`}>
                {text}
            </p>
        </div>
    )
}

export default OfferTag